import RequestService from 'services/RequestService';
import { makeApiRequest } from 'actions/api';

export const GET_NARVAR_PREFERENCES = 'GET_NARVAR_PREFERENCES';
export const GET_NARVAR_PREFERENCES_RESPONSE = 'GET_NARVAR_PREFERENCES_RESPONSE';

export const getNarvarPreferences = () =>
  makeApiRequest({
    requestType: GET_NARVAR_PREFERENCES,
    method: RequestService.getNarvarPreferences,
  });

export const CREATE_NARVAR_PREFERENCES = 'CREATE_NARVAR_PREFERENCES';
export const CREATE_NARVAR_PREFERENCES_REQUEST = 'CREATE_NARVAR_PREFERENCES_REQUEST';
export const CREATE_NARVAR_PREFERENCES_ERROR = 'CREATE_NARVAR_PREFERENCES_ERROR';
export const CREATE_NARVAR_PREFERENCES_RESPONSE = 'CREATE_NARVAR_PREFERENCES_RESPONSE';

export const createNarvarPreferences = options => async dispatch => {
  const response = await dispatch(
    makeApiRequest({
      requestType: CREATE_NARVAR_PREFERENCES,
      method: RequestService.createNarvarPreferences,
      params: { options: options },
    })
  );

  if (response.ok) {
    dispatch(getNarvarPreferences());
  }
};

export const UPDATE_NARVAR_PREFERENCES = 'UPDATE_NARVAR_PREFERENCES';
export const UPDATE_NARVAR_PREFERENCES_REQUEST = 'UPDATE_NARVAR_PREFERENCES_REQUEST';
export const UPDATE_NARVAR_PREFERENCES_ERROR = 'UPDATE_NARVAR_PREFERENCES_ERROR';
export const UPDATE_NARVAR_PREFERENCES_RESPONSE = 'UPDATE_NARVAR_PREFERENCES_RESPONSE';

export const updateNarvarPreferences = (modifiedDatetime, options) => async dispatch => {
  const response = await dispatch(
    makeApiRequest({
      requestType: UPDATE_NARVAR_PREFERENCES,
      method: RequestService.updateNarvarPreferences,
      params: { modifiedDatetime, options },
    })
  );

  if (response.ok) {
    dispatch(getNarvarPreferences());
  }
};
